"use strict";
var modifierKeyToProp = {
  "Alt": "altKey",
  "Control": "ctrlKey",
  "Meta": "metaKey",
  "Shift": "shiftKey"
};
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}
function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}
module.exports = getEventModifierState;
